import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { LoadingSpinnerComponent } from '../../../../../aptem-component-library/components/loading-spinner/loading-spinner.component';
import { LoadingSpinnerConfig } from '../../../../../aptem-component-library/components/loading-spinner/loading-spinner.models';
import { PageConfig } from './page.models';

@Component({
    selector: 'app-page',
    imports: [CommonModule, LoadingSpinnerComponent],
    templateUrl: './page.component.html',
    styleUrl: './page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponent {
  @Input() public config: PageConfig | null = null;
  @Input({ required: true }) public content: TemplateRef<any> | null = null;
  @Input() public action: TemplateRef<any> | null = null;

  protected loadingSpinnerConfig: LoadingSpinnerConfig = {
    size: 'lg',
  };
}
